'use client';

function hasHtml(value: string): boolean {
  return /<[a-z][\s\S]*>/i.test(value);
}

function stripOuterP(html: string): string {
  return html.replace(/^\s*<p>([\s\S]*)<\/p>\s*$/i, '$1');
}

export function stripQuestionHtml(value: string | null | undefined): string {
  if (!value) return '';
  return value
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\s+/g, ' ')
    .trim();
}

export function QuestionName({ name }: { name?: string | null }) {
  if (!name) return null;
  if (!hasHtml(name)) return <>{name}</>;
  return <span dangerouslySetInnerHTML={{ __html: stripOuterP(name) }} />;
}
